<template>
  <Header :title="title">
    <h4 class="subheading">
      Please answer the questions below and click
      <strong>Generate quote</strong> to generate a customised conveyancing quote.
    </h4>
  </Header>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "QuoteQuestionsHeader",
  components: { Header },
  props: {
    title: null
  }
};
</script>